<template lang="pug">
.view-user
  ui-navbar-panel.mb-20(backLink="users", backLinkText="К списку")
    template(slot="filters")
      span Пользователь # {{ this.$route.params.id }} &nbsp;
      b {{ this.editUser.fullName }}

    template
      b-button.is-primary(@click="save", icon-left="check", :disabled="!this.canEdit()") Сохранить

  .container(v-if="!editUser.$state.loading")
    form-component(
      v-model="editUser",
      form="edit-user-form",
      ref="form"
    )
</template>

<script>
import User from '@/models/User';
import BButton from 'buefy/src/components/button/Button';
import BField from 'buefy/src/components/field/Field';
import BIcon from 'buefy/src/components/icon/Icon';

import { mapGetters } from 'vuex';

export default {
  name: 'view-edit-user',
  components: { BIcon, BField, BButton },

  data: () => ({
    editUser: new User(),
  }),

  computed: {
    ...mapGetters(['user']),
  },

  watch: {
    $route() {
      this.loadState();
    },
  },

  methods: {
    canEdit() {
      return this.user.id === this.editUser.id || this.user.isAdmin;
    },

    save() {
      this.$refs.form.save();
    },

    loadState() {
      if (this.$route.params.id) {
        this.editUser.id = +this.$route.params.id;
        this.editUser.$find(+this.$route.params.id, {
          include: 'platform,role',
        });
      }
    },
  },

  created() {
    this.loadState();
  },
};
</script>
